"use strict";
import {visualizeCompleteness} from "../tabManager";
import TerracePlanner from "../index";
import * as terracePlannerExcessQuantity from "./excessQuantity";
import * as terracePlannerAccessoriesUI from "../accessories/accessoriesUI";
import {setPdfVisibility} from "../buttonBar";

export function init() {
    if(TerracePlanner.tabConfig.summary.complete) {
        visualizeCompleteness('summary');
    }

    terracePlannerExcessQuantity.init();
    terracePlannerAccessoriesUI.init();
}